import React, { Component } from "react";
import { connect } from "react-redux";
import RightSide from "../Sides/RightSide";

class MblinkHdmi2Fakra extends Component {
  constructor(props) {
    super(props);
    this.state = { };

  }

  componentDidMount() {    
  }

  render() {
    return (
      <React.Fragment>
        <div className="module ptb-100">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 col-md-8">
                <article className="post">
                  <div className="post-preview">
                    <img
                      src="/img/products/hdmi2fakra.jpg"
                      alt="article"
                      className="img-fluid"
                    />
                  </div>
                  <div className="post-wrapper">
                    <div className="post-header">
                      <h1 className="post-title">HDMI2Fakra Adaptor (HFA)</h1>
                      <ul className="post-meta">
                        <li>April 01, 2022</li>
                      </ul>
                    </div>
                    <div className="post-content">
                      <p>
                        The most beautiful feature of the Mblink HDMI2Fakra adapter is that you can plug in a device with an HDMI output and see it on your vehicle's own screen.
                      </p>
                      <p>
                      In this way, you can connect your Apple TV and Android Box devices to your vehicle very easily.
                      </p>

                    </div>
                    <div className="post-more pt-4 align-items-center d-flex">
                      <a href="/#" className="btn solid-btn mr-2">
                        Documentation <span className="ti-file"></span>
                      </a>                      
                    </div>
                    <div className="post-footer">
                      <div className="post-tags">
                        <a href="/#">HDMI</a>
                        <a href="/#">Fakra</a>
                        <a href="/#">Mercedes</a>
                        <a href="/#">Retrofit</a>
                      </div>
                    </div>
                  </div>
                </article>
              </div>
                            
              <RightSide/>

            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default connect(state => ({
  state,
}))(MblinkHdmi2Fakra);
